import { ChevronDown, InfoCircle, IntersectCircle } from "@untitledui/icons";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { ProductChips } from "./product-chips";

type TopProduct = { title: string; commissionRate: number | null; imageUrl: string | null };

interface SmartUnboxGroupHeaderProps {
  name: string;
  isExpanded: boolean;
  onToggle: () => void;
  groupSize?: number;
  topProducts?: TopProduct[];
}

export const SmartUnboxGroupHeader = ({
  name,
  isExpanded,
  onToggle,
  groupSize,
  topProducts,
}: SmartUnboxGroupHeaderProps) => {
  return (
    <div className="flex items-start relative max-w-[60ch]">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        className="flex-shrink-0 pr-2 pt-0.5 hover:opacity-70 transition-opacity"
        aria-label={isExpanded ? "Collapse group" : "Expand group"}
      >
        <ChevronDown
          className="w-5 h-5 text-foreground transition-transform duration-150"
          style={{ transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)" }}
        />
      </button>

      <div className="flex flex-col min-w-0 flex-1 gap-1.5">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 min-w-0">
            <span className="text-[15px] font-medium text-primary truncate" title={name}>
              Smart Group
            </span>
            <Tooltip
              title="Smart Unbox Group"
              description="Identical collaborations are automatically grouped together. Click the chevron to expand and see individual collaborations in more detail."
              placement="top"
            >
              <TooltipTrigger className="inline-flex items-center flex-shrink-0">
                <InfoCircle className="w-4 h-4 text-quaternary hover:text-tertiary cursor-help transition-colors" />
              </TooltipTrigger>
            </Tooltip>
          </div>

          {groupSize !== undefined && groupSize > 1 && (
            <span className="inline-flex items-center gap-1 h-[21px] pl-1.5 pr-2 py-0.5 rounded-[6px] bg-[#f9f5ff] border border-[#e9d7fe] flex-shrink-0">
              <IntersectCircle className="w-3 h-3 text-[#6941c6]" />
              <span className="text-xs font-medium text-[#6941c6] leading-[18px]">{groupSize} Collabs</span>
            </span>
          )}
        </div>

        {topProducts && topProducts.length > 0 && <ProductChips products={topProducts} groupTooltip />}
      </div>
    </div>
  );
};
